import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

export interface ICreateThreadRequestAction {
  data: {
    interventionId: number;
    message: string;
    subject: string;
    traderId: number;
  };
  functions: {
    closeModal: () => void;
    error: (err: any) => void;
  };
}

function createThreadRequest(
  draft: Draft<IInterventionData>,
  _: PayloadAction<ICreateThreadRequestAction>,
) {
  draft.createThread.config.isLoading = true;
}

export default createThreadRequest;
